import { useEffect } from "react";
import { useLocation } from "react-router-dom"; // Uncomment this

const ScrollToTop = (props) => {
    const location = useLocation(); // Uncomment this
    
    useEffect(() => {
      window.scrollTo({top: 0, left: 0, behavior: 'instant' }); // Changed to 'instant'
    }, [location.pathname]); // This is the key fix - listen for route changes
  
    return <>
        {props.children}
    </>
};

export default ScrollToTop;